import { IframeAction, StorageType } from "../types";
import { getIframeData, updateStorageData } from "./iframe";
import { safeLocalStorage } from "./storage";

const SOFTWALL_RENDER_COUNT_KEY = "BT_AM_SOFTWALL_RENDER_COUNT";
const SOFTWALL_DISMISS_COUNT_KEY = "BT_AM_SOFTWALL_DISMISS_COUNT";

type WallInteractionKeys = "dismiss" | "render";

export const incrementInteractionCount = (key: WallInteractionKeys) =>
  getInteractionCountData(key).then((count) =>
    saveInteractionCountData(count + 1, key),
  );

export async function getInteractionCountData(
  key: WallInteractionKeys,
): Promise<number> {
  const storageKey =
    key === "dismiss" ? SOFTWALL_DISMISS_COUNT_KEY : SOFTWALL_RENDER_COUNT_KEY;
  const interactionCountStr = safeLocalStorage.get(storageKey);
  if (interactionCountStr) return Number(interactionCountStr);

  return getIframeData(StorageType.Local, storageKey)
    .then((iframeData) => {
      if (iframeData) {
        // set data to local storage so on next page load
        // it will be available without need to post message to iframe
        safeLocalStorage.set(storageKey, iframeData);
        return Number(iframeData);
      }
      return 0;
    })
    .catch(() => 0);
}

export const saveInteractionCountData = (
  count: number,
  key: WallInteractionKeys,
): Promise<void> =>
  updateStorageData(
    IframeAction.Set,
    StorageType.Local,
    key === "dismiss" ? SOFTWALL_DISMISS_COUNT_KEY : SOFTWALL_RENDER_COUNT_KEY,
    count.toString(),
  );

export const clearAllInteractionsCount = () =>
  Promise.all([
    updateStorageData(
      IframeAction.Delete,
      StorageType.Local,
      SOFTWALL_DISMISS_COUNT_KEY,
    ),
    updateStorageData(
      IframeAction.Delete,
      StorageType.Local,
      SOFTWALL_RENDER_COUNT_KEY,
    ),
  ]);
